export default {
    App: {
        'Browse stock equipment': '浏览库存设备',
        'Contact Kalmar': '联系 Kalmar',
        'Create new': '新建',
        'Dealer community': 'Dealer community',
        'Download failed': '下载失败',
        'Failed to get service reports': '获取保养报告失败',
        'Kalmar Care service request': '卡尔玛关怀服务请求',
        'Kalmar Training Academy': '卡尔玛培训学院',
        'Kalmar Used Equipment': '卡尔玛二手设备',
        'Loading MyKalmar': '正在加载 MyKalmar',
        'Login again': '再次登录',
        'Maintenance reporting': '维护报告',
        'Maintenance schedule': '维护计划',
        'Manuals': '手册',
        'My Cases': '我的案例',
        'MyKalmar homepage': '我的卡尔玛主页',
        'MyParts': 'MyParts',
        'Navigating to MyParts failed': '导航至 MyParts 失败',
        'No service reports found': '未找到保养报告',
        'None': '无',
        'Open Dealer community': ' 打开经销商社区',
        'Open MyKalmar INSIGHT': '打开MyKalmar INSIGHT',
        'Open MyKalmar STORE': '打开 MyKalmar STORE',
        'Open used equipment sales portal': '打开二手设备销售平台',
        'Parts order history': '零件订单历史',
        'Read more and subscribe': '阅读更多并订阅',
        'Read more and register': '阅读更多并注册',
        'Register Kalmar equipment': '注册卡尔玛设备',
        'Request training': '请求培训',
        'Request service': '请求服务',
        'Show manuals search': '显示手册搜索',
        'Show all ({{ equipmentLength }}) equipment': '显示所有 ({{ equipmentLength }}) 设备',
        'Show all Kalmar contacts': '显示所有 Kalmar 联系人',
        'Show all cases': '显示所有案例',
        'Show on calendar': '在日历上显示',
        'Show requests': '查看请求',
        'Try again': '重试',
        'You are now logged out from MyKalmar': '您现已登出 MyKalmar',
        'Open TechSight': '打开 TechSight',
        'Solve smarter: your one-stop information source': '更智能地解决问题：您的一站式信息源',
    },
    BackToTop: {
        'Back to top': '返回顶部',
    },
    Banner: {
        'Boost driving skills and technical expertise with Kalmar Training Academy specialized training courses, designed to keep your team & equipment safe and reliable.': '提升驾驶技能和技术专长，参加 Kalmar 培训学院的专业培训课程，旨在确保您的团队和设备的安全与可靠。',
        'Check details for your equipment until they last.': '查看您的设备详情，直到售罄。',
        'Discover how to get the most out of your equipment.': '了解如何充分利用您的设备。',
        'Ensure uptime, optimize your operations, and much more.': '确保正常运行时间、优化您的运营等等。',
        'Explore Kalmar Services': '探索卡尔玛服务',
        'FLASH Sale is now on - Save up to 70%': '闪购现已开启 - 最高可节省70%',
        'Go to STORE': '前往 STORE',
        'Learn more': '了解更多',
        'Register in STORE now': '立即在 STORE 注册',
        'Selected Kalmar Genuine Parts now discounted in the MyKalmar STORE Outlet.': 'MyKalmar STORE Outlet 现已对精选的卡尔玛正品配件进行折扣。',
        'Take your team’s performance to the next level!': '将您的团队绩效提升到一个新的水平！',
    },
    BulletinsTab: {
        'Bulletin': '公告',
        'Bulletins': '公告',
        'Product': '产品',
        'Subject': '主题',
        'Date': '日期',
        'Open pdf': '打开PDF',
        'Search bulletins': '搜索公告',
        'Select equipment': '选择设备',
        'Category': '类别',
        'Select category': '选择类别',
        'No bulletins for your fleet.': '您的车队暂无公告。',
        'Bulletins are currently available for select equipment types only. We are actively expanding coverage to include the rest of your fleet in upcoming updates.': '目前，公告仅针对部分设备类型提供。我们正在积极扩大覆盖范围，将在后续更新中纳入您车队中的其余设备。',
        'Bulletins are visible to Kalmar internal users only.': '公告仅对 Kalmar 内部用户可见。',
    },
    Common: {
        'All': '全部',
        'Language': '语言',
        'Select language': '选择语言',
        'Availability': '可用性',
        'Call the number': '拨打号码',
        'called': '已调用',
        'Cancel': '取消',
        'Close': '关闭',
        'completed': '已完成',
        'Contracts': '合同',
        'Customer number': '客户编号',
        'declined': '已拒绝',
        'Description': '描述',
        'Details': '详情',
        'Email': '电子邮件',
        'Maintenance': '维护',
        'Monthly': '每月',
        'Monthly report': '月度报告',
        'My Equipment': '我的设备',
        'N/A': '无数据',
        'Name': '名称',
        'No data': '没有数据',
        'No data for this time period': '该时间段无数据',
        'OK': '确定',
        'ordered': '已订购',
        'Other': '其他',
        'Stock equipment': '库存设备',
        'Register Kalmar equipment': '注册卡尔玛设备',
        'Request submission failed': '请求提交失败',
        'Response Time': '响应时间',
        'scheduled': '已计划',
        'See details': '查看详情',
        'Send': '发送',
        'Serial number': '序列号',
        'Show on page': '在页面上显示',
        'Site': '站点',
        'Something went wrong': '出错',
        'Status': '状态',
        'today': '今天',
        'Type': '类型',
        'Unknown': '未知',
        'User': '用户',
        'Yearly': '每年',
        'Yearly trend': '年度趋势',
        'Search': '搜索',
        'Open': '打开',
        'Welcome to MyKalmar': '欢迎使用 MyKalmar',

    },
    ContactWidget: {
        'Contact us!': '联系我们',
        'Need help?  Or need to know more about our services?': '需要帮助？或者需要了解更多关于我们的服务',
        'Phone': '电话',
        'Send email': '发送电子邮件',
    },
    CustomerSelector: {
        'No results found with': '未找到结果',
        'Search with name, city, street address or sold-to number': 'Search with name, city, street address or sold-to number',
        'Select customer': '选择客户',
    },
    DataRequestForm: {
        'Acceptance of Data Notice': '接受数据声明',
        'Company name': '公司名称',
        'Contact us': '联系我们',
        'Data Act Notice': '数据法案声明',
        'Data request sent': '数据请求已发送',
        'Date of data concerned by the request': '请求涉及的数据日期',
        'Details': '详情',
        'Error sending data request:': '发送数据请求时出错：',
        'Fill request form': '填写请求表单',
        'Form for data access request': '数据访问请求表单',
        'I have read and agree to the': '我已阅读并同意',
        'Name': '姓名',
        'No customer selected': '未选择客户',
        'Open comments': '开放评论',
        'Or alternatively,': '或者，',
        'Position/relationship with the Company': '职位/与公司的关系',
        'Products concerned by the request (e.g. serial number)': '请求涉及的产品（例如序列号）',
        'Something went wrong': '出错',
        'Thank you for your data request': '感谢您的数据请求',
        'Past data': '过去数据',
        'Present data': '当前数据',
        'Required data': '所需数据',
        'Alternatively, please contact us at': '或者，请通过以下方式与我们联系',
    },
    DealerCommunity: {
        'Sales & general information': '销售和一般信息.',
        'Marketing & products': '市场营销和产品.',
        'Technical library': '技术库.',
        'News': '新闻消息.',
        'Kalmar contacts': '卡尔玛联系方式',
    },
    DocumentationTab: {
        'Manuals': '手册',
        'Manual': '手册',
        'Open': '打开',
        'Select language': '选择语言',
        'See more manuals in other languages': '查看更多其他语言版本的手册',
        'Search manuals with serial number': '通过序列号搜索手册',
    },
    EmptyWidgets: {
        'Buy genuine parts': '购买原装配件',
        'By registering your equipment you can see manuals, contracts and more.': '注册您的设备后，您可以查看手册、合同和更多信息',
        'Create a case': '创建案例',
        'Do you have an inquiry?': '您有咨询吗？',
        'Description (serial numbers of all the equipment you want to register)': '描述（您要注册的所有设备的序列号）',
        'Kalmar Services': '卡尔玛服务',
        'Performance management tool for cargo handling operations': '用于货物装卸作业的绩效管理工具',
        'Phone number': '电话号码',
        'Registration request received': '注册请求已收到',
        'Thank you for your registration request. We will handle your request as soon as possible.': '感谢您的注册请求。我们将尽快处理您的请求。',
    },
    EquipmentAvailability: {
        'Equipment Type': '设备类型',
        'Month': '月',
        'Quarter': '季度',
        'Year': '年',
    },
    EquipmentAvailabilityByType: {
        'Time spent': '花费的时间',
    },
    Footer: {
        'General conditions': '通用条款',
        'Kalmar Digital Service Terms & Conditions': 'Kalmar 数字服务条款和条件',
        'Privacy policy': '隐私条款',
        'Kalmar in Social Media': '卡尔玛在社交媒体上',
        'EU Data Act': '欧盟数据法案',
        'For data questions, please contact': '如需数据问题，请联系',
    },
    KalmarInsightWidget: {
        'equipment': '设备',
        'Expired license': '过期许可证',
        'License expiring soon': '即将过期许可证',
        'Manage users': '用户管理',
        'Number of MyKalmar INSIGHT users': 'MyKalmar INSIGHT 用户数',
        'Valid license': '有效许可证',
    },
    LanguageSelector: {
        'Select language': '选择语言',
    },
    LoadingFailure: {
        'Loading cases failed': '加载案例失败',
        'Loading equipment availability failed': '加载设备可用性失败',
        'Loading equipment failed': '加载设备失败',
        'Loading failed': '加载失败',
        'Loading maintenance schedule failed': '加载维护计划失败',
        'Loading preventive maintenance data failed': '加载预防性维护数据失败',
        'Loading response time failed': '加载响应时间失败',
        'Loading sales orders failed': '加载销售订单失败',
        'Retry': '重试',
    },
    MaintenanceCalendar: {
        'Equipment name': '设备名称',
        'Maintenance description': '维护说明',
        'No maintenance scheduled for the selected day.': '选择日期无维护计划。',
    },
    MaintenanceReporting: {
        'Equipment Availability': '设备可用性',
        'Preventive Maintenance': '预防性维护',
    },
    MaintenanceReportingWidget: {
        'Average duration from breakdown to the first service operation start': 'Average duration from breakdown to the first service operation start',
        'Average percentage the equipment was available': '设备可用的平均百分比',
        'Planned maintenance operations that were completed on time': 'Planned maintenance operations that were completed on time',
    },
    MaintenanceScheduleWidget: {
        'No upcoming maintenances': '没有即将到来的维护',
        'Upcoming maintenances': '即将到来的维护',
    },
    MasterHeader: {
        'Go to MyKalmar STORE or MyKalmar INSIGHT': '访问 MyKalmar STORE 或 MyKalmar INSIGHT',
        'Language': '语言',
        'Log out': '登出',
        'MyKalmar profile': 'MyKalmar 个人资料',
        'You can go to MyKalmar STORE and MyKalmar INSIGHT by clicking here': '点击这里可以进入MyKalmar STORE和MyKalmar INSIGHT',
    },
    MyCasesWidget: {
        'An unknown value': '未知数值',
        'Automation': '自动化',
        'Case': '案例',
        'changed from': '更改自',
        'Comment': '备注',
        'n/a': '不适用',
        'New comment': '新备注',
        'No recent updates to cases': '案例无最近更新',
        'Priority': '优先权',
        'Recent updates': '最近更新',
        'Resolution_Date__c': 'Resolution date',
        'STORE': 'STORE',
        'to': '至',
        'updated': '已更新',
        'Updated at': '更新于'
    },
    MyEquipment: {
        'Bulletins': '公告',
        'Contracts': '合约',
        'Digital subscriptions': '数字订阅',
        'Documentation': '文档',
        'Equipment details': '设备详情',
        'Equipment name': '设备名称',
        'MyKalmar INSIGHT': 'MyKalmar INSIGHT',
        'Leasing': '租赁',
        'Model': '设备型号',
        'Search equipment with name, site, serial number or type': '按名称、站点、序列号或类型搜索设备',
        'Search with name, serial number or type': '按名称、序列号或类型搜索',
        'Serial number': '序列号',
        'Short-term rental': '短期租赁',
    },
    MyEquipmentItem: {
        'Contract ends': '合同结束',
        'Contract started': '合同开始',
        'No contracts': '暂无合同',
        'Contact Kalmar for signing a contract': '联系Kalmar签订合同',
        'Equipment details': '设备详情',
        'insight': 'MyKalmar INSIGHT',
        'leasing': '租赁',
        'Machine card': '机卡',
        'maintenance': '维护',
        'Maintenance schedule': '维护计划',
        'Manufacturing year': '制造年份',
        'Model': '设备型号',
        'No data': '没有数据',
        'No equipment found': '未找到设备',
        'Open': '打开',
        'Order parts': '订购零件',
        'Owner': '所有者',
        'rental-short-term': '短期租赁',
        'Running hours': '设备运行小时数',
        'See Insights': '查看洞见',
        'Serial number': '序列号',
        'Today': '今天',
        'Preventive maintenance reports': '预防性维护报告',
        'No preventive maintenance reports': '没有预防性维护报告',
        'Preventive maintenance reports are generated after certified Kalmar service inspections. Book a service inspection with our local team to keep your equipment running reliably.':
            '经过卡尔玛（Kalmar）认证的维修检查后，系统将生成预防性维护报告。请向我们的当地团队预约维修检查，以确保您的设备可靠运行。',
        'Learn more about Kalmar maintenance': '了解有关卡尔玛维护服务的更多信息',
        'Learn more about Kalmar Care': '了解有关Kalmar Care服务模式的更多信息',
        'Maintenance records are temporarily unavailable': '维护记录暂时不可用',
        'Service order': '服务订单',
        'Maintenance interval': '维护间隔',
        'Date': '日期',
        'Faults': '故障',
        'Comments': '备注',
        'View comments': '查看备注',
        'Open pdf': '打开PDF',
        'Chapter': '章节',
        'Checkpoint': '检查点',
        'Comment': '评论',
    },
    MyEquipmentWidget: {},
    MyPartsWidget: {
        'At warehouse': '仓库中',
        'Customer PO': '客户参考订单号',
        'Delivered': '已送达',
        'My last parts orders': '我最后的零件订单',
        'No orders': '无订单',
        'Note: this order will be delivered in multiple shipments.': '注意：此订单将分多个批次进行配送。',
        'Order number': '订单号',
        'Order received': '订单已接收',
        'Processing': '处理中',
        'Shipment': '货运',
        'Shipped': '已发货',
        'Tracking': '追踪',
        'Tracking information not available at the moment': '追踪信息目前不可用',
        'Not available': '不可用',
        'Hide tracking': '隐藏追踪',
        'View tracking': '查看追踪',
        'Please wait for tracking information...': '请等待追踪信息...',
        'Est. Delivery': '预计交货',
    },
    NotFound: {
        'Go to home page': '前往首页',
        'Page not found': '页面未找到',
        'The page may have been moved or you may not have the necessary rights to access this page': '该页面可能已移动或您可能没有访问该页面的必要权限',
    },
    PaginationTable: {
        "itemsCurrentlyShownText": "显示 {{maxItemAmount}} 条中的 {{shownItemAmount}} 条"
    },
    PreventiveMaintenanceCompletion: {
        'Completed': '已完成',
        'completed in': '完成时间',
        'Count': '计数',
        'No data for': '没有数据',
        'Not completed': '未完成',
        'Percentage': '百分比',
        'Planned': '已计划',
        'tasks': '任务',
    },
    ResponseTime: {
        'Action started': '开始的操作',
        'avg. response time': '平均响应时间',
        'Call started': '通话开始',
        'in': 'in',
        'Operation': '操作',
        'Response time': '响应时间',
    },
    ServiceRequests: {
        'All': '全部',
        'Breakdown Maintenance': '故障维修',
        'Closed': '已关闭',
        'Corrective Maintenance': '纠正性维护',
        'Created': '创建',
        'Create new': '创建新的',
        'Customer name': '客户名称',
        'Enter detailed description of the maintenance request...': '输入维护请求的详细描述...',
        'expertise, or swift troubleshooting.': '专业知识或快速故障排除',
        'Fill request form': '填写请求表',
        'Maintenance type': '维护类型',
        'Mark request as complete': '标记请求完成',
        'No customer selected': '没有选择客户',
        'No service requests': '没有服务请求',
        'Other Maintenance': '其他维护',
        'Request received': '收到请求',
        'Request urgent repairs, additional maintenance': '请求紧急维修、额外维护',
        'Phone number': '电话号码',
        'Preferred maintenance date (Kalmar cannot guarantee maintenance on this date)': '首选维护日期（卡尔玛不能保证在此日期进行维护',
        'Preventive Maintenance': '预防性维护',
        'Search request': '搜索请求',
        'Equipment location': '设备位置',
        "This can't be changed": '此项不可更改',
        'Thank you for your service request. We will contact you by phone as soon as possible during business hours.': '感谢您的服务请求。我们将在工作时间内尽快与您电话联系。',
        'Your reference': '您的参考',
    },
    SessionExpirationModal: {
        'Log in again': '再次登录',
        'You have been logged out due to inactivity': '您已由于未活动登出',
        'Your session has expired': '您的会话已过期',
    },
    SiteSelector: {
        'Customer': '客户',
        'No sites with equipment': '没有有设备的站点',
        'Select a customer': '选择客户',
        'Selected': '已选择',
        'Show all sites': '显示所有地点',
        'Showing all sites': '显示所有站点',
        'Recently visited': '最近访问的',
    },
    StockEquipment: {
        'Price': '价格',
        'Currency': '货币',
        'Please select a currency for the price': '请为价格选择一种货币',
        'Contact email': '联系邮箱',
        'Added': '已添加',
        'All': '全部',
        'Cancel': '取消',
        'Close': '关闭',
        'Configuration number': '配置编号',
        'Confirm': '确认',
        'Create stock equipment': '创建库存设备',
        'Datasheet': '数据表',
        'Datasheets': '数据表',
        'Delete': '删除',
        'Delete this equipment. This action can’t be undone.': '删除此设备。此操作无法撤销。',
        'Description': '描述',
        'Details': '详情',
        'Documents': '文件',
        'Edit': '编辑',
        'Engine type': '发动机类型',
        'Equipment added successfully': '设备添加成功',
        'Equipment adding failed': '设备添加失败',
        'Estimated availability': '预计可用时间',
        'If you are interested in this equipment, please contact your local Kalmar sales representative or email us at': '如果您对此设备感兴趣，请联系您当地的卡尔玛销售代表，或发送电子邮件至',
        'Manufacturing year': '制造年份',
        'MAU location': 'MAU 地点',
        'Mark as active': '标记为可用',
        'Mark as inactive': '标记为下架',
        'Mark as reserved': '标记为已预订',
        'Mark as sold': '标记为已售',
        'Cancel reservation': '取消预订',
        'Copy and create new': '复制并新建',
        'More options': '更多选项',
        'ACTIVE': '可用',
        'INACTIVE': '下架',
        'RESERVED': '已预订',
        'SOLD': '已售',
        'Mark equipment as sold. This action can’t be undone.': '将此设备标记为已售。此操作无法撤销。',
        'Model': '型号',
        'No equipment found': '未找到设备',
        'Picture': '图片',
        'Pictures': '图片',
        'Ready': '可用',
        'Region': '地区',
        'Regions': '地区',
        'Search equipment with name, serial number, description, model or site...': '按名称、序列号、描述、型号或站点搜索设备...',
        'Search with name, serial number or description': '按名称、序列号或描述搜索',
        'See all stock equipment ready to deliver': '查看所有准备交付的库存设备',
        'Select equipment type': '选择设备类型',
        'Select region': '选择地区',
        'Send': '发送',
        'Show on page': '每页显示',
        'Something went wrong': '出现错误',
        'Specification': '规格说明',
        'Specifications': '规格说明',
        'Stock equipment details': '库存设备详情',
        'Type': '类型',
        'Upload': '上传',
        'Picture is too large. Please upload a picture smaller than 8 MB.': '图片太大。请上传小于 8 MB 的图片。',
        'Contact': '联系',
        'Stock equipment': '库存设备',
        'Show more': '显示更多',
        'Show less': '显示更少',
    },
    TimeUnitLinks: {
        'Show': '显示',
    },
    Tooltips: {
        'Content': 'Content',
        'Recent reports': 'Recent reports',
    },
    TrainingRequests: {
        'All': '全部',
        'Closed': '已关闭',
        'Created': '创建',
        'Create new': '创建新的',
        'Customer name': '客户名称',
        'Eco Driving Training': '节能驾驶培训',
        'Enter detailed description of the training request...': '请输入培训请求的详细描述...',
        'Number of participants': '参与人数',
        'Operator Training': '操作员培训',
        'Phone number': '电话号码',
        'Preferred time frame for training (Kalmar can’t guarantee training during this time frame, the training is reserved only after Kalmar has contacted you)': '首选培训时间段（卡尔玛无法保证在此时间段内进行培训，培训仅在卡尔玛与您联系后方可预订）',
        'Product Training': '产品培训',
        'Reach out to one of our training specialists today.': '立即联系我们的培训专家。',
        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.': '接受行业专业人士提供的重型设备和施工现场技能的实践培训。',
        'Request received': '收到请求',
        'Search training': '搜索培训',
        'Show requests': '查看请求',
        'Technical Training': '技术培训',
        'Thank you for your training request. We will contact you by phone as soon as possible during business hours.': '感谢您的培训请求。我们将在工作时间内尽快通过电话与您联系。',
        'Training type': '培训类型',
    },
};

